<template>
  <div @keydown="handleKeydown" class="update-opportunity">
    <close-opportunity-from-chat
      v-if="showCloseChat"
      @closeHalfModal="closeHalfModal()"
      @refresh="$emit('saved')"
      :fromOpportunityDesktop="true"
      :fromOmnichannelDesktop="isFromOmnichannelDesktop"
      :opportunity="unchangedOpportunity"
      :newestChat="newestChat"
    />

    <validation-observer
      v-if="!hasSalesStageRequest && !hasOpportunityRequest && unchangedOpportunity"
      class="form-holder nice-Vscroll"
      ref="formValidation"
    >
      <card-top-info-component
        @new-task="openNewTaskModal()"
        @singleVoipCall="singleVoipCall()"
        @closeByChat="showCloseByChat()"
        @photo-change="setContactPhoto($event)"
        :opportunity="unchangedOpportunity"
        :isFromExternalCall="isFromExternalCall"
        :fromOmnichannelDesktop="isFromOmnichannelDesktop"
        :newestChat="newestChat"
        :editable="!pedagogicalWorkflow"
        :photo="contactPhoto"
        is-photo-editable
        v-model="name"
      />

      <div v-if="hasAIPermission" class="tab-selector">
        <div
          @click="handleTabSelection('info')"
          :class="{ active: currentTab == 'info' }"
          class="tab-selector-item"
        >
          <Icon icon="teenyicons:id-solid" class="tab-icon" />

          <span>Informações</span>
        </div>

        <div
          @click="handleTabSelection('ai')"
          :class="{ disabled: authFailedImhub, active: currentTab == 'ai' }"
          class="tab-selector-item"
        >
          <Icon icon="fluent:sparkle-20-filled" class="tab-icon" />

          <span>Assistente IA</span>
        </div>
      </div>

      <div v-show="currentTab == 'info'" class="sub-form-group">
        <tags-selector :limit="5" label="Etiquetas" v-model="tags" />

        <opportunity-tma :opportunity="unchangedOpportunity" />

        <qualification v-model="probability" />

        <div class="low-gap-sub-group">
          <opportunity-won-lost-buttons
            @set-won="handleCloseDeal('Won')"
            @set-lost="handleCloseDeal('Lost')"
            :opportunity="unchangedOpportunity"
          />

          <div
            v-if="
              unchangedOpportunity?.state_type == 'Won' &&
              hasImNicEnroll &&
              checkContractStatus() &&
              checkImNicToken() &&
              !pedagogicalWorkflow
            "
            @click="openEnroll"
            class="enrollment-button"
          >
            <i class="icon-upload-file enroll-icon" />

            Gerar Matrícula
          </div>

          <contract-status
            v-if="unchangedOpportunity.contract"
            :contract="unchangedOpportunity.contract"
            :dependent="{
              isResponsable: unchangedOpportunity.is_responsible,
              studentName: unchangedOpportunity.student_name,
              studentDocument: unchangedOpportunity.student_document,
            }"
          />

          <div v-if="erpContractIds.length" class="sgf-contracts">
            <div class="sgf-contracts-title">Contratos SGF</div>

            <div class="sgf-contracts-list">
              <span v-for="contractId in erpContractIds" :key="contractId" class="sgf-contract-chip">
                {{ contractId }}
              </span>
            </div>
          </div>

          <div v-if="unchangedOpportunity.state_type == 'Lost'" class="lost-reason-description">
            <div class="lost-title">{{ getFormatedClosedType(unchangedOpportunity.closed_type) }}.</div>

            <div class="lost-description">
              {{ unchangedOpportunity.closed_description || "Sem descrição" }}
            </div>
          </div>

          <opportunity-step
            @updateTaskCount="handleUpdateTaskCount()"
            :sales-stages="saleStages"
            :opportunity="unchangedOpportunity"
            ruled-stage-change
            v-model="sales_stage_id"
          />

          <b-button @click="openNewTaskModal()" class="add-task-button" variant="primary">
            <feather-icon icon="PlusCircleIcon" />

            Adicionar Tarefa
          </b-button>
        </div>

        <div v-if="isFromExternalCall && external_phone_status != 'paused'" class="call-component-holder">
          <div class="call-ongoing">
            Em atendimento

            <div class="white-green-circle" />
          </div>

          <b-button @click="terminateCall" class="dial-stop" variant="danger">
            <feather-icon icon="PhoneOffIcon" size="18" />

            Finalizar
          </b-button>
        </div>

        <line-component color="#E5E5E5" />

        <b-tabs fill v-model="activeTab">
          <b-tab title="Dados" class="b-tab-style">
            <legend>Informações</legend>

            <validation-provider #default="{ errors }" name="Nome do Contato" rules="required" vid="name">
              <small class="v-err text-danger">{{ errors[0] }}</small>

              <input-field
                @input="handleContactNameInput()"
                id="contact_name"
                placeholder="Nome Completo"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.name"
              />
            </validation-provider>

            <validation-provider #default="{ errors }" :rules="phoneRules" name="celular" vid="phone">
              <small class="v-err text-danger">{{ errors[0] }}</small>

              <small class="text-danger" v-if="needDDD"> O número precisa conter algum DDD </small>

              <vue-phone-number-input
                @update="setMobileNumberInformation"
                :border-radius="0"
                :color="colorOfNumberInput"
                :default-country-code="countryCode"
                :translations="{
                  countrySelectorLabel: 'Código do país',
                  countrySelectorError: 'Escolha um país',
                  phoneNumberLabel: 'Celular',
                  example: 'Exemplo :',
                }"
                show-code-on-list
                class="phone-input"
                size="lg"
                valid-color="#046af3"
                v-model="phone_number"
              />
            </validation-provider>

            <input-field
              id="email"
              placeholder="email@dominio.com.br"
              borderRadius="5px"
              type="email"
              trim
              v-model="contact.email"
            />

            <line-component color="#E5E5E5" />

            <input-field
              @editClick="redirectToContacts()"
              id="contact"
              placeholder="Contato vinculado"
              is-static
              trim
              v-model="contact.name"
            />

            <span @click="showModalWithRoleCheck('bv-transfer-opportunity')" class="cursor-pointer">
              <workspace-item
                label="Workspace"
                class="form-boxes"
                variant="input"
                v-model="currentWorkspace"
              />
            </span>

            <validation-provider
              v-if="role != 'salesRep'"
              #default="{ errors }"
              name="Responsável"
              rules="required"
              vid="currentUser"
            >
              <small class="v-err text-danger mb-1">{{ errors[0] }}</small>

              <span @click="showModalWithRoleCheck('bv-list_users')">
                <user-item label="Responsável" class="form-boxes" variant="input" v-model="currentUser" />
              </span>
            </validation-provider>

            <user-item
              v-if="visit_generator && platform_customizations.has_street_generation"
              label="Gerador de Visita"
              class="form-boxes"
              variant="input"
              disabled
              v-model="visit_generator"
            />

            <small v-if="hasProductPriceError && !products" class="v-err text-danger">
              {{ requiredProductError }}
            </small>

            <product-item
              @selected="selectProduct($event)"
              @clear="unsetProduct()"
              :class="{ 'error-border': hasProductPriceError && !products }"
              :products="products"
              id="productItem"
              allow-price-edit
              use-quantity
            />

            <b-form-group
              v-if="!pedagogicalWorkflow"
              :class="{ 'error-border': hasProductPriceError && !price }"
              class="price-field"
            >
              <money
                id="price"
                class="form-control price"
                placeholder="Venda"
                trim
                disabled
                v-model="price"
              />

              <label for="price" class="floating">
                {{ platform_customizations.terms?.price_term || "Valor de venda" }}:
              </label>
            </b-form-group>

            <v-select
              v-if="$service.hasOpportunityType()"
              :options="opportunity_types"
              :reduce="(option) => option.id"
              id="opportunity_type"
              label="name"
              placeholder="Tipo"
              v-model="opportunity_type_id"
            />

            <div v-if="!pedagogicalWorkflow" class="sub-form-group">
              <legend>Informações Complementares</legend>

              <input-date-selector v-model="contact.birthdate" />

              <input-field
                :mask="['###.###.###-##']"
                id="CPF"
                placeholder="CPF"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.document"
              />

              <input-field
                id="RG"
                placeholder="RG"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.id_number"
              />

              <legend>Endereço</legend>

              <input-field
                @blur="handlePostalCodeBlur()"
                :mask="['#####-###']"
                id="cep"
                placeholder="CEP"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.postal_code"
              />

              <input-field
                id="address_line_1"
                placeholder="Endereço"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.address_line1"
              />

              <input-field
                id="address_line_2"
                placeholder="Complemento"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.address_line2"
              />

              <v-select
                label="title"
                placeholder="Estado"
                :options="states"
                :reduce="(option) => option.id"
                v-model="contact.state_code"
              />

              <input-field
                id="cidade"
                placeholder="Cidade"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.city_name"
              />

              <input-field
                id="bairro"
                placeholder="Bairro"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.neighborhood"
              />

              <legend>Redes Sociais</legend>

              <input-field
                id="instagram"
                placeholder="@instagram"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.instagram"
              />

              <input-field
                id="facebook"
                placeholder="@facebook"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.facebook"
              />

              <input-field
                id="linkedin"
                placeholder="@linkedIn"
                borderRadius="5px"
                type="text"
                trim
                v-model="contact.linkedin"
              />
            </div>

            <div class="sub-form-group">
              <legend>Black List</legend>

              <div class="sub-form-group-check">
                <input
                  id="blacklist_input"
                  type="checkbox"
                  class="custom-checkbox"
                  v-model="contact.is_blacklisted"
                />

                <label for="blacklist_input"> Ignorar contato em automações e disparos </label>
              </div>
            </div>

            <b-form-textarea
              id="blacklist_reason"
              placeholder="Motivo do bloqueio"
              v-model="contact.blacklist_reason"
            />

            <div
              v-if="platform_customizations.responsible_check && !pedagogicalWorkflow"
              class="sub-form-group"
            >
              <legend>Dependentes</legend>

              <div class="sub-form-group-check">
                <input
                  id="responsible_input"
                  type="checkbox"
                  class="custom-checkbox"
                  v-model="is_responsible"
                />

                <label for="responsible_input"> Não é aluno? </label>
              </div>
            </div>

            <div v-if="is_responsible" class="sub-form-group">
              <validation-provider #default="{ errors }" name="Nome" rules="required" vid="student_name">
                <small class="v-err text-danger">{{ errors[0] }}</small>

                <input-field
                  id="name"
                  placeholder="Nome Completo"
                  type="text"
                  borderRadius="5px"
                  trim
                  v-model="student_name"
                />
              </validation-provider>

              <validation-provider #default="{ errors }" name="CPF" rules="required" vid="student_document">
                <small class="v-err text-danger">{{ errors[0] }}</small>

                <input-field
                  :mask="['###.###.###-##']"
                  id="student_document"
                  placeholder="CPF"
                  type="text"
                  borderRadius="5px"
                  trim
                  v-model="student_document"
                />
              </validation-provider>
            </div>

            <description-field v-model="description" />

            <input-field
              id="erp_contract_id"
              placeholder="ID Externo"
              type="text"
              borderRadius="5px"
              trim
              v-model="erp_contract_id"
            />

            <legend>Anexo</legend>

            <attachment-field v-model="attachment" />
          </b-tab>

          <b-tab :title="!pedagogicalWorkflow ? 'Origem/Mídia' : 'Origem'" class="b-tab-style">
            <legend>Origem</legend>

            <validation-provider
              v-if="isCardManual"
              #default="{ errors }"
              name="Origem"
              rules="required"
              vid="source_type"
            >
              <small class="v-err text-danger">{{ errors[0] }}</small>

              <v-select
                :options="source_types"
                :reduce="(option) => option.id"
                :clearable="false"
                id="source_type"
                label="title"
                placeholder="Origem"
                v-model="source_type"
              />
            </validation-provider>

            <div @click="showBlockedContetError()" v-else class="blocked-content">
              {{ getBlockedContentSourceType(unchangedOpportunity.source_type) }}
            </div>

            <div v-if="!pedagogicalWorkflow" class="sub-form-group">
              <legend>Mídia</legend>

              <validation-provider
                v-if="isCardManual"
                #default="{ errors }"
                name="Mídia"
                rules="required"
                vid="media_id"
              >
                <small class="v-err text-danger">{{ errors[0] }}</small>

                <v-select
                  :options="medias"
                  :reduce="(option) => option.id"
                  :clearable="false"
                  id="media"
                  label="name"
                  placeholder="Mídia"
                  v-model="media_id"
                />
              </validation-provider>

              <div v-else @click="showBlockedContetError()" class="blocked-content">
                {{ unchangedOpportunity?.media?.name }}
              </div>
            </div>

            <input-field
              v-if="!pedagogicalWorkflow"
              id="campaign_url"
              placeholder="Site"
              borderRadius="5px"
              type="text"
              trim
              v-model="campaign_url"
            />

            <div v-if="!pedagogicalWorkflow" class="sub-form-group">
              <legend>Campanha</legend>

              <validation-provider #default="{ errors }" name="Campanha" vid="campaign">
                <small class="v-err text-danger">{{ errors[0] }}</small>

                <v-select
                  :options="campaigns"
                  :reduce="(option) => option.id"
                  id="campaign"
                  label="name"
                  placeholder="Campanha"
                  v-model="campaign_id"
                />
              </validation-provider>
            </div>

            <div v-if="$service.isIm() && unchangedOpportunity.marketing_campaign" class="sub-form-group">
              <legend>Campanha de Marketing</legend>

              <div @click="showBlockedContetError('Campo visual não editável')" class="blocked-content">
                {{ unchangedOpportunity?.marketing_campaign?.name }}
              </div>
            </div>

            <input-field
              v-if="form_id"
              id="form_id"
              placeholder="ID do Formulário Externo"
              type="text"
              isDisabled
              trim
              v-model="form_id"
            />

            <div v-if="role == 'admin'" @click="redirectToInternalAdmin()" class="edit-lists-redirect">
              <i class="icon-pencil-line" />

              <div>Editar Listas</div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <div v-if="newestChat && !authFailedImhub" v-show="currentTab == 'ai'" class="sub-form-group">
        <a-i-assistent :dialogId="newestChat.id" />
      </div>
    </validation-observer>

    <div v-else class="spinner-holder">
      <b-spinner />
    </div>

    <div class="bottom-menu">
      <b-button v-if="!isFromOmnichannelDesktop" @click="$emit('close')" variant="light"> Cancelar </b-button>

      <b-button
        @click="updateOpportunity()"
        :disabled="hasSalesStageRequest || hasOpportunityRequest"
        variant="primary"
      >
        <b-spinner v-if="hasSaveRequest" small />

        <div v-else>Salvar</div>
      </b-button>
    </div>

    <ClosingOpportunityModals
      v-if="unchangedOpportunity"
      @saveDeal="handleSaveDeal($event)"
      :opportunityProp="unchangedOpportunity"
    />

    <b-modal
      id="bv-sgf_contract_history"
      class="modal-dialog"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <sgf-contract-history-form
        v-if="unchangedOpportunity"
        @skip="skipSgfHistory()"
        @confirm="confirmSgfHistory($event)"
        :opportunity="sgfHistoryOpportunity"
        :has-save-request="hasSgfHistoryRequest"
      />
    </b-modal>

    <b-modal class="modal-dialog" id="bv-list_users" hide-footer hide-header>
      <user-list @closed="$bvModal.hide('bv-list_users')" @selected="selectUser($event)" />
    </b-modal>

    <b-modal
      id="update-opportunity-task-form-stage-swap"
      class="modal-dialog"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <task-form
        v-if="unchangedOpportunity"
        @saved="
          ($bvModal.hide('update-opportunity-task-form-stage-swap'),
          handleUpdateTaskCount(),
          handleCloseDeal(willWinTheOpportunity ? 'Won' : 'Lost'))
        "
        @close="$bvModal.hide('update-opportunity-task-form-stage-swap')"
        :opportunity="unchangedOpportunity"
        register-only
        lock-user
      />
    </b-modal>

    <b-modal
      v-if="unchangedOpportunity"
      id="update-opportunity-task-form"
      class="modal-dialog"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <task-form
        @assigned="$emit('assigned')"
        @saved="($bvModal.hide('update-opportunity-task-form'), $emit('saved'))"
        @close="$bvModal.hide('update-opportunity-task-form')"
        :opportunity="unchangedOpportunity"
        :from-opportunity-form="true"
      />
    </b-modal>

    <b-modal id="verify-cancel-opportunity" hide-footer hide-header no-close-on-backdrop>
      <verify-cancel
        @save="($bvModal.hide('verify-cancel-opportunity'), updateOpportunity())"
        @close="($bvModal.hide('verify-cancel-opportunity'), $emit('close'))"
      />
    </b-modal>

    <b-modal class="modal-dialog" id="bv-transfer-opportunity" hide-footer hide-header>
      <transfer-workspace
        @transfered="$emit('transferred')"
        @close="$bvModal.hide('bv-transfer-opportunity')"
        :opportunity="unchangedOpportunity"
      />
    </b-modal>
  </div>
</template>

<script>
import { BButton, BFormGroup, BFormTextarea, BSpinner, BTabs, BTab } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import moment from "moment";
import { Money } from "v-money";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import AIAssistent from "@/views/components/Omnichannel/AIAssistent.vue";
import AttachmentField from "@/views/forms/components/AttachmentField.vue";
import CardTopInfoComponent from "@/views/components/Omnichannel/CardTopInfoComponent.vue";
import CloseOpportunityFromChat from "@/views/components/CloseOpportunityFromChat.vue";
import ClosingOpportunityModals from "@/views/components/ClosingOpportunityModals.vue";
import ContractStatus from "@/views/forms/components/ContractStatus.vue";
import SgfContractHistoryForm from "@/views/forms/components/SgfContractHistoryForm.vue";
import DescriptionField from "@/views/forms/components/DescriptionField.vue";
import { getAddressByCep } from "@/config/index.js";
import InputDateSelector from "@/views/components/InputDateSelector.vue";
import InputField from "@/views/components/InputField.vue";
import Line from "@/views/components/Line.vue";
import OpportunityTma from "@/views/components/OpportunityTma.vue";
import OpportunityWonLostButtons from "@/views/forms/components/OpportunityWonLostButtons.vue";
import ProductItem from "@/views/components/ProductItem.vue";
import Qualification from "@/views/components/Qualification.vue";
import TagsSelector from "@/views/components/TagsSelector.vue";
import TransferWorkspace from "@/views/components/TransferWorkspace.vue";
import UserItem from "@/views/components/UserItem.vue";
import UserList from "@/views/components/UserList.vue";
import VerifyCancel from "@/views/forms/components/VerifyCancel.vue";
import WorkspaceItem from "@/views/components/WorkspaceItem.vue";

export default {
  components: {
    BButton,
    BFormGroup,
    BFormTextarea,
    BSpinner,
    BTabs,
    BTab,
    Icon,
    Money,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    VuePhoneNumberInput,

    AIAssistent,
    AttachmentField,
    CardTopInfoComponent,
    CloseOpportunityFromChat,
    ClosingOpportunityModals,
    ContractStatus,
    SgfContractHistoryForm,
    DescriptionField,
    InputDateSelector,
    InputField,
    OpportunityTma,
    OpportunityWonLostButtons,
    ProductItem,
    Qualification,
    TagsSelector,
    TransferWorkspace,
    UserItem,
    UserList,
    VerifyCancel,
    WorkspaceItem,

    "line-component": Line,

    OpportunityStep: () => import("@/views/components/OpportunityStep.vue"),
    TaskForm: () => import("@/views/forms/TaskForm.vue"),
  },

  props: {
    id: {
      type: Number,
      required: false,
      default: null,
    },

    opportunity_prop: {
      type: Object || null,
      required: false,
      default: null,
    },

    newestChat: {
      type: Object || null,
      required: false,
      default: null,
    },

    isFromOmnichannelDesktop: {
      type: Boolean,
      required: false,
      default: false,
    },

    isFromExternalCall: {
      type: Boolean,
      required: false,
      default: false,
    },

    watchVerifyCancel: {
      type: Boolean,
      required: false,
      default: false,
    },

    autoSetWon: {
      type: Boolean,
      required: false,
      default: false,
    },

    autoSetLost: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      //tabs: info, ai
      currentTab: "info",
      activeTab: 0,

      saleStages: [],

      currentUser: null,
      currentWorkspace: null,
      opportunity: null,
      unchangedOpportunity: null,

      hasSaveRequest: false,
      hasOpportunityRequest: false,
      hasSalesStageRequest: false,
      hasVoipCredentialsRequest: false,

      showCloseChat: false,
      isCardManual: false,
      willWinTheOpportunity: false,
      willLoseTheOpportunity: false,
      hasProductPriceError: false,
      hasSgfHistoryRequest: false,
      isClosedBeforeSgfHistory: false,

      //Opportunity Data
      name: null,
      sales_stage_id: null,
      probability: 40,
      products: [],
      price: 0,
      source_type: null,
      media_id: null,
      campaign_id: null,
      campaign_url: null,
      description: null,
      is_responsible: false,
      student_name: null,
      student_document: null,
      opportunity_type_id: null,
      workspace_id: null,
      visit_generator: null,
      form_id: null,
      closed_type: null,
      closed_description: null,
      trigger_room_status: null,
      erp_contract_id: null,
      tags: [],
      attachment: null,

      //Contact Data
      contact: {},
      contactPhoto: null,
      phone_number: null,

      //Phone Number Data
      countryCode: "BR",
      editedPhoneNumber: null,
      colorOfNumberInput: "#d8d6de",
      needDDD: false,

      allPossibleAutomaticSources: ["URA", "Bella", "FormularioSite"],
      sgfHistoryWorkflowIds: [2, 5],

      requiredProductError:
        'O campo "Produto" e "Preço" são obrigatórios para a conclusão da oportunidade como "Ganha".',

      defaultSourceTypesFilter: ["URA", "Bella", "FormularioSite", "Importacao"],
      pedagogicalWorkflowSourceTypesFilter: [
        "URA",
        "Bella",
        "FormularioSite",
        "Importacao",
        "FormularioRedesSociais",
        "Messenger",
        "Comentario",
        "Offline",
        "FormularioExterno",
        "Inbox",
        "Direct",
      ],
    };
  },

  computed: {
    phoneRules() {
      return this.contact?.meta_user_id ? "" : "required";
    },

    hasImNicEnroll() {
      return this.$store.getters["app/getUserWorkspace"].platform_id == 1;
    },

    shouldRegisterSgfHistory() {
      return this.hasImNicEnroll && this.sgfHistoryWorkflowIds.includes(this.workflowId);
    },

    erpContractIds() {
      return this.unchangedOpportunity?.erp_contract_ids || [];
    },

    sgfHistoryOpportunity() {
      return { ...this.unchangedOpportunity, products: this.products };
    },

    role() {
      return this.$store.getters["app/getUserRole"];
    },

    user() {
      return this.$store.getters["app/getUserData"];
    },

    medias() {
      return this.$store.getters["opportunityStore/getMedias"];
    },

    campaigns() {
      return this.$store.getters["opportunityStore/getCampaigns"];
    },

    states() {
      return this.$store.getters["opportunityStore/getSourceStates"];
    },

    opportunity_types() {
      return this.$store.getters["opportunityStore/getOpportunityTypes"];
    },

    reasons_lost() {
      return this.$store.getters["opportunityStore/getLostReasons"];
    },

    platform_customizations() {
      return this.$store.getters["whiteLabel/getPlatform"].settings;
    },

    external_phone_status() {
      return this.$store.getters["externalPhone/getPhoneStatus"];
    },

    workflowId() {
      return this.$service.getWorkflowId();
    },

    pedagogicalWorkflow() {
      return this.$service.isPedagogical();
    },

    authFailedImhub() {
      return this.$store.getters["websocket/authFailedImhub"];
    },

    hasAIPermission() {
      return this.$service.hasAIPermission();
    },

    source_types() {
      const deepClone = require("lodash");

      let options = deepClone.cloneDeep(this.$store.getters["opportunityStore/getSourceTypes"]);

      let sources = Object.values(options);

      if (this.pedagogicalWorkflow) {
        return sources.filter((option) => !this.pedagogicalWorkflowSourceTypesFilter.includes(option.id));
      }

      return sources.filter((option) => !this.defaultSourceTypesFilter.includes(option.id));
    },
  },

  created() {
    this.fetchOpportunity();
    this.fetchSalesStages();
    this.fetchLostReasons();
    this.fetchCampaigns();
    this.fetchMedias();
    this.fetchOpTypes();
  },

  watch: {
    watchVerifyCancel() {
      this.handleVerifyCancel();
    },
  },

  methods: {
    openNewTaskModal() {
      this.$bvModal.show("update-opportunity-task-form");
    },

    openEnroll() {
      this.$store.dispatch("contract/setOpportunityForContract", this.unchangedOpportunity);

      this.$bvModal.show("bv-enrollment_form");
    },

    showCloseByChat() {
      this.showCloseChat = true;
    },

    showModalWithRoleCheck(modal) {
      if (this.role !== "salesRep") {
        this.$bvModal.show(modal);
      }
    },

    showBlockedContetError(
      message = "Este campo está bloqueado para edição por se tratar de um card externo",
    ) {
      this.$bvToast.toast(message, {
        title: "Campo Bloqueado",
        variant: "warning",
        solid: true,
      });
    },

    closeHalfModal() {
      this.showCloseChat = false;
    },

    terminateCall() {
      this.$store.commit("externalPhone/TRIGGER_END_CALL");
    },

    checkContractStatus() {
      return (
        !this.unchangedOpportunity.contract ||
        this.unchangedOpportunity.contract?.payment_status == "Canceled"
      );
    },

    checkImNicToken() {
      return !!localStorage.getItem("imNicToken");
    },

    checkIfCardIsManual() {
      if (this.allPossibleAutomaticSources.includes(this.unchangedOpportunity.source_type)) {
        this.isCardManual = false;

        return;
      }

      this.isCardManual = true;
    },

    checkIfWillCloseTheOpportunity() {
      if (this.unchangedOpportunity.sales_stage_id == this.sales_stage_id) return false;

      const saleStage = this.saleStages.find((stage) => stage.id === this.sales_stage_id);

      if (!saleStage) return false;

      this.willWinTheOpportunity = saleStage.type === "Won";
      this.willLoseTheOpportunity = saleStage.type === "Lost";

      if (this.willWinTheOpportunity) {
        if (!this.products) {
          this.handleProductPriceError();
        } else {
          this.$bvModal.show("bv-close_deal_won");
        }

        return true;
      }

      if (this.willLoseTheOpportunity) {
        this.$bvModal.show("bv-close_deal_lost");

        return true;
      }

      return false;
    },

    checkIfWillReopenTheOpportunity() {
      const saleStage = this.saleStages.find((stage) => stage.id === this.sales_stage_id);

      if (!saleStage) return false;

      if (
        saleStage.type !== "Won" &&
        saleStage.type !== "Lost" &&
        (this.unchangedOpportunity.state_type === "Lost" || this.unchangedOpportunity.state_type === "Won")
      ) {
        if (this.checkForUnsavedData()) {
          this.updateThenReopenOpportunity(this.sales_stage_id);
        } else {
          this.reopenOpportunity(this.sales_stage_id);
        }

        return true;
      }

      return false;
    },

    checkForUnsavedData() {
      const opportunity = this.getClearOpportunity();

      const isEqual = (val1, val2) => {
        if (typeof val1 !== typeof val2) return false;

        if (Array.isArray(val1) && Array.isArray(val2)) {
          if (val1.length !== val2.length) return false;
          return val1.every((item, index) => isEqual(item, val2[index]));
        } else if (typeof val1 === "object" && val1 !== null && val2 !== null) {
          const keys1 = Object.keys(val1);
          return keys1.every((key) => isEqual(val1[key], val2[key]));
        }

        return val1 === val2;
      };

      for (const key in opportunity) {
        if (Object.prototype.hasOwnProperty.call(opportunity, key)) {
          if (!(key in this.unchangedOpportunity)) {
            if (opportunity[key] !== undefined) return true;

            continue;
          }

          if (!isEqual(opportunity[key], this.unchangedOpportunity[key])) return true;
        }
      }

      return false;
    },

    getFormatedClosedType(closedType) {
      return this.reasons_lost.find((reason) => reason.id == closedType)?.name || "Motivo não encontrado";
    },

    selectUser(user) {
      this.currentUser = user;

      this.$bvModal.hide("bv-list_users");
    },

    selectProduct($event) {
      const products = $event?.products;

      this.products = products;

      if (products?.length) {
        let price = 0;

        products.forEach((product) => {
          price += product.price * product.quantity;
        });

        this.price = price;
      } else {
        this.price = 0;
      }
    },

    unsetProduct() {
      this.products = [];
      this.price = 0;
    },

    setMobileNumberInformation(update) {
      this.countryCode = update.countryCode;
      this.editedPhoneNumber = update.formatNational;

      if (this.editedPhoneNumber && this.editedPhoneNumber.length < 10 && this.countryCode === "BR") {
        this.colorOfNumberInput = "#ea5556";
        this.needDDD = true;
      } else {
        this.needDDD = false;
      }
    },

    setContactPhoto(photo) {
      this.contactPhoto = photo;
    },

    setSavedUploads(savedOpportunity) {
      if (!savedOpportunity) return;

      this.attachment = savedOpportunity.file || null;
      this.contactPhoto = savedOpportunity.contact?.photo || null;
    },

    setLocalOpportunity() {
      if (!this.unchangedOpportunity.price) this.unchangedOpportunity.price = 0;

      this.name = this.unchangedOpportunity.name;
      this.sales_stage_id = this.unchangedOpportunity.sales_stage_id;
      this.probability = this.unchangedOpportunity.probability;
      this.price = this.unchangedOpportunity.price;
      this.source_type = this.unchangedOpportunity.source_type;
      this.media_id = this.unchangedOpportunity.media_id;
      this.campaign_id = this.unchangedOpportunity.campaign_id;
      this.workspace_id = this.unchangedOpportunity.workspace_id;
      this.campaign_url = this.unchangedOpportunity.campaign_url;
      this.description = this.unchangedOpportunity.description;
      this.is_responsible = this.unchangedOpportunity.is_responsible;
      this.student_name = this.unchangedOpportunity.student_name;
      this.student_document = this.unchangedOpportunity.student_document;
      this.opportunity_type_id = this.unchangedOpportunity.opportunity_type_id;
      this.visit_generator = this.unchangedOpportunity.visit_generator;
      this.form_id = this.unchangedOpportunity.form_id;
      this.erp_contract_id = this.unchangedOpportunity.erp_contract_id;

      this.products = this.unchangedOpportunity.products;
      this.tags = this.unchangedOpportunity.tags;
      this.attachment = this.unchangedOpportunity.file || null;
      this.contact = { ...this.unchangedOpportunity.contact };
      this.contactPhoto = this.unchangedOpportunity.contact.photo || null;
      this.phone_number = this.unchangedOpportunity.contact.phone_number;

      this.currentUser = this.unchangedOpportunity.user;

      this.currentWorkspace = this.unchangedOpportunity.workspace;

      this.opportunity = this.unchangedOpportunity;

      this.checkIfCardIsManual();
    },

    getBlockedContentSourceType(blockedContent) {
      const blockedContents = {
        Bella: "Bella",
        FormularioSite: "Formulário Site",
        URA: "URA",
      };

      return blockedContents[blockedContent];
    },

    getClearOpportunity() {
      if (this.contact) {
        delete this.contact.workspace_id;
        delete this.contact.workspace;
        delete this.contact.opportunities;
        delete this.contact.created_at;
        delete this.contact.updated_at;
      }

      const cleanProducts = this.products?.map((product) => {
        return {
          id: product.id,
          quantity: product.quantity,
          price: product.price,
        };
      });

      const shouldSyncPhoto = Boolean(this.contactPhoto || this.unchangedOpportunity.contact.photo);

      if (shouldSyncPhoto) {
        this.contact.photo = this.contactPhoto;
      } else {
        delete this.contact.photo;
      }

      const opportunity = {
        id: this.unchangedOpportunity.id,
        name: this.name,
        opportunity_type_id: this.opportunity_type_id,
        source_type: this.source_type,
        media_id: this.media_id,
        workspace_id: this.workspace_id,
        is_responsible: this.is_responsible,
        student_name: this.student_name,
        student_document: this.student_document,
        description: this.description,
        campaign_id: this.campaign_id,
        campaign_url: this.campaign_url,
        probability: this.probability,
        user_id: this.currentUser?.id,
        products: cleanProducts || [],
        price: this.price,
        contact_id: this.contact.id,
        erp_contract_id: this.erp_contract_id,

        tags: this.tags,

        contact: this.contact,
      };

      opportunity.contact.phone_number = this.$service.clearPhoneNumber(this.phone_number);
      opportunity.contact.country_code = this.countryCode;

      const shouldSyncAttachment = Boolean(this.attachment || this.unchangedOpportunity.file);

      if (shouldSyncAttachment) {
        opportunity.file = this.attachment;
      }

      return opportunity;
    },

    handleContactNameInput() {
      if (this.pedagogicalWorkflow) this.name = this.contact.name;
    },

    handleKeydown(event) {
      if (event.key === "Enter") {
        event.preventDefault();

        this.updateOpportunity();
      }
    },

    handleUpdateTaskCount() {
      if (this.unchangedOpportunity.task?.count) {
        this.unchangedOpportunity.task.count++;
      } else {
        this.unchangedOpportunity.task = { count: 1 };
      }
    },

    handleProductPriceError() {
      this.hasProductPriceError = true;

      this.$bvToast.toast(this.requiredProductError, {
        title: "Oportunidade sem Produto!",
        autoHideDelay: 2500,
        variant: "warning",
        toaster: "b-toaster-top-left",
        solid: true,
      });

      const productItem = document.getElementById("productItem");

      if (productItem) productItem.scrollIntoView({ block: "center", behavior: "smooth" });
    },

    handleCloseDeal(state_type) {
      if (this.unchangedOpportunity.state_type == state_type) {
        if (this.checkForUnsavedData()) {
          this.updateThenReopenOpportunity();
        } else {
          this.reopenOpportunity();
        }

        return;
      }

      this.willWinTheOpportunity = state_type === "Won";
      this.willLoseTheOpportunity = state_type === "Lost";

      if (!this.unchangedOpportunity.task?.count) {
        this.$bvModal.show("update-opportunity-task-form-stage-swap");

        this.$bvToast.toast("Uma oportunidade deve ter ao menos uma tarefa para poder mudar de etapa!", {
          title: `Oportunidade sem tarefa!`,
          autoHideDelay: 2500,
          variant: "warning",
          toaster: "b-toaster-top-left",
          solid: true,
        });

        return;
      }

      let newSaleStageIndex;

      if (this.willWinTheOpportunity)
        newSaleStageIndex = this.saleStages.findIndex((stage) => stage.type === "Won");

      if (this.willLoseTheOpportunity)
        newSaleStageIndex = this.saleStages.findIndex((stage) => stage.type === "Lost");

      if (!newSaleStageIndex) {
        this.$bvToast.toast("Não foi possível encontrar o estágio de conclusão no workspace atual", {
          title: "Etapa de conclusão não encontrada",
          variant: "danger",
          solid: true,
        });

        return;
      }

      this.sales_stage_id = this.saleStages[newSaleStageIndex].id;

      this.updateOpportunity();
    },

    handleSaveDeal(event) {
      if (!event?.state) return;

      if (event.state == "Won") this.trigger_room_status = event.opportunity?.trigger_room_status;

      if (event.state == "Lost") {
        this.closed_type = event.opportunity?.closed_type;
        this.closed_description = event.opportunity?.closed_description;
      }

      this.$bvModal.hide(`bv-close_deal_${event.state.toLowerCase()}`);

      if (this.shouldRegisterSgfHistory) {
        this.isClosedBeforeSgfHistory = false;

        this.$bvModal.show("bv-sgf_contract_history");

        return;
      }

      this.saveThenClose();
    },

    skipSgfHistory() {
      this.$bvModal.hide("bv-sgf_contract_history");

      if (this.isClosedBeforeSgfHistory) {
        this.$emit("saved");

        return;
      }

      this.saveThenClose();
    },

    async confirmSgfHistory(history) {
      this.hasSgfHistoryRequest = true;

      const isClosed = await this.ensureClosedBeforeSgfHistory();
      const isRegistered = isClosed && (await this.sendContractHistory(history));

      this.hasSgfHistoryRequest = false;

      if (!isRegistered) return;

      this.$bvModal.hide("bv-sgf_contract_history");

      this.$bvToast.toast("Histórico registrado no contrato do SGF.", {
        title: "Histórico registrado!",
        autoHideDelay: 2500,
        variant: "success",
        toaster: "b-toaster-top-left",
        solid: true,
      });

      this.$emit("saved");
    },

    handleFormError() {
      this.$bvToast.toast("Por favor, preencha todos os campos obrigatórios", {
        title: "Campos obrigatórios",
        variant: "warning",
        solid: true,
      });

      const errorField = document.querySelector(".v-err");

      if (errorField) errorField.scrollIntoView({ block: "center", behavior: "smooth" });
    },

    handleVerifyCancel() {
      if (this.checkForUnsavedData() || this.unchangedOpportunity.sales_stage_id != this.sales_stage_id) {
        this.$bvModal.show("verify-cancel-opportunity");
      } else {
        this.$emit("close");
      }
    },

    handleTabSelection(tab) {
      if (this.authFailedImhub) {
        this.$bvToast.toast("Autenticação no IMHUB falhou, por favor, deslogue e tente novamente.", {
          title: "Não autorizado no IMHUB",
          variant: "warning",
          solid: true,
        });

        return;
      }

      this.currentTab = tab;
    },

    redirectToContacts() {
      if (this.$route.path == "/contacts") return;

      this.$store.commit(
        "contactStore/setContactIdFromOpportunityRedirect",
        this.unchangedOpportunity.contact.id,
      );

      this.$router.push(`${"/contacts"}`);
    },

    redirectToInternalAdmin() {
      this.$router.push("/lists");
    },

    async validateForm() {
      let formRefs = this.$refs.formValidation;

      const result = await formRefs.validate();

      if (!result) {
        const errors = formRefs.errors;

        if (errors.media_id?.length || errors.source_type?.length) {
          this.activeTab = 1;
        } else {
          this.activeTab = 0;
        }

        await this.$nextTick();

        this.handleFormError();

        return false;
      }

      return true;
    },

    fetchLostReasons() {
      if (this.reasons_lost.length) return;

      this.$store.dispatch("opportunityStore/fetchLostReasons");
    },

    fetchCampaigns() {
      if (this.campaigns.length) return;

      this.$store.dispatch("opportunityStore/fetchCampaigns");
    },

    fetchMedias() {
      if (this.medias.length) return;

      this.$store.dispatch("opportunityStore/fetchMedias");
    },

    fetchOpTypes() {
      if (this.opportunity_types.length) return;

      this.$store.dispatch("opportunityStore/fetchOpTypes");
    },

    fetchSalesStages() {
      this.hasSalesStageRequest = true;

      const params = [
        {
          query: "workflow_id",
          param: this.$service.getWorkflowId(),
        },
      ];

      this.$store
        .dispatch("admin/fetchSalesStages", this.$service.formatQueryParam(params))
        .then((response) => {
          this.saleStages = response.data;
        })
        .finally(() => {
          this.hasSalesStageRequest = false;

          this.$nextTick(() => {
            if (this.autoSetWon) {
              this.handleCloseDeal("Won");
            }

            if (this.autoSetLost) {
              this.handleCloseDeal("Lost");
            }
          });
        });
    },

    fetchOpportunity() {
      this.hasOpportunityRequest = true;

      if (this.opportunity_prop) {
        this.unchangedOpportunity = this.opportunity_prop;

        this.setLocalOpportunity(this.opportunity_prop);

        this.hasOpportunityRequest = false;

        return;
      }

      this.$store
        .dispatch("opportunityStore/fetchOne", this.id)
        .then((response) => {
          this.unchangedOpportunity = response.data;

          this.setLocalOpportunity(response.data);
        })
        .finally(() => {
          this.hasOpportunityRequest = false;
        });
    },

    singleVoipCall() {
      if (this.hasVoipCredentialsRequest) return;

      this.hasVoipCredentialsRequest = true;

      this.$store
        .dispatch("externalPhone/getSipCredentials", this.user.id)
        .then((response) => {
          if (response.data.voip_username && response.data.voip_password) {
            this.$store.commit("externalPhone/CHANGE_USER_CREDENTIALS", {
              user_name: response.data.voip_username,
              password: response.data.voip_password,
            });

            this.$store.commit("externalPhone/CHANGE_SINGLE_OPPORTUNITY_ID", this.unchangedOpportunity.id);

            this.$store.commit("externalPhone/CHANGE_IS_SINGULAR_CALL", true);
            this.$store.commit("externalPhone/CHANGE_IS_DIALING", true);
            this.$store.commit("externalPhone/CHANGE_STATUS", "onHold");
            this.$store.commit("externalPhone/TRIGGER_START_CALLS");
          } else {
            this.$bvToast.toast("Usuário sem credenciais de VoIP neste workspace", {
              title: "Usuário sem acesso",
              variant: "warning",
              solid: true,
            });
          }
        })
        .finally(() => {
          this.hasVoipCredentialsRequest = false;
        });
    },

    async updateOpportunity() {
      if (this.hasSaveRequest) return;

      const isValid = await this.validateForm();

      if (!isValid) return;

      if (this.checkIfWillCloseTheOpportunity()) return;

      if (this.checkIfWillReopenTheOpportunity()) return;

      this.hasSaveRequest = true;

      const opportunity = this.getClearOpportunity();

      this.$store
        .dispatch("opportunityStore/save", opportunity)
        .then((response) => {
          this.setSavedUploads(response.data);

          if (response.data?.sales_stage_id != this.sales_stage_id) {
            this.moveOpportunity();

            return;
          }

          this.$emit("saved");
        })
        .finally(() => {
          this.hasSaveRequest = false;
        });
    },

    ensureClosedBeforeSgfHistory() {
      if (this.isClosedBeforeSgfHistory) return Promise.resolve(true);

      return this.saveThenClose({ deferSaved: true })
        .then((response) => {
          this.isClosedBeforeSgfHistory = Boolean(response);

          return this.isClosedBeforeSgfHistory;
        })
        .catch(() => false);
    },

    saveThenClose(options = {}) {
      if (this.checkForUnsavedData()) return this.updateThenClose(options);

      return this.closeOpportunity(options);
    },

    updateThenClose(options = {}) {
      const formRefs = this.$refs.formValidation;

      return formRefs.validate().then((success) => {
        if (!success) {
          this.handleFormError();

          return false;
        }

        this.hasSaveRequest = true;

        const opportunity = this.getClearOpportunity();

        return this.$store
          .dispatch("opportunityStore/save", opportunity)
          .then(() => this.closeOpportunity(options))
          .finally(() => {
            this.hasSaveRequest = false;
          });
      });
    },

    updateThenReopenOpportunity(sales_stage_id = null) {
      const formRefs = this.$refs.formValidation;

      formRefs.validate().then((success) => {
        if (success) {
          this.hasSaveRequest = true;

          const opportunity = this.getClearOpportunity();

          this.$store
            .dispatch("opportunityStore/save", opportunity)
            .then(() => {
              this.reopenOpportunity(sales_stage_id);
            })
            .finally(() => {
              this.hasSaveRequest = false;
            });

          return;
        }

        this.handleFormError();
      });
    },

    async handlePostalCodeBlur() {
      if (!this.contact.postal_code) return;

      const cleanCep = this.contact.postal_code.replace(/\D/g, "");

      if (cleanCep.length !== 8) return;

      try {
        const address = await getAddressByCep(cleanCep);

        if (address.erro) {
          this.$bvToast.toast("CEP inválido!", {
            title: `CEP Inválido!`,
            autoHideDelay: 2500,
            variant: "danger",
            toaster: "b-toaster-top-left",
            solid: true,
          });

          return;
        }

        this.contact.address_line1 = address.logradouro;
        this.contact.neighborhood = address.bairro;
        this.contact.city_name = address.localidade;
        this.contact.state_code = address.uf;
        this.contact.address_line2 = address.complemento;
      } catch (error) {
        this.$bvToast.toast("Erro ao buscar CEP!", {
          title: `Erro ao buscar CEP! tente novamente ou digite manualmente.`,
          autoHideDelay: 2500,
          variant: "danger",
          toaster: "b-toaster-top-left",
          solid: true,
        });
      }
    },

    closeOpportunity({ deferSaved = false } = {}) {
      this.hasSaveRequest = true;

      const closingData = {
        id: this.unchangedOpportunity.id,
        workspace_id: this.unchangedOpportunity.workspace_id,

        data: {
          state_type: this.willWinTheOpportunity ? "Won" : "Lost",
          closed_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
      };

      if (this.willWinTheOpportunity) closingData.data.trigger_room_status = this.trigger_room_status;

      if (this.willLoseTheOpportunity) {
        closingData.data.closed_type = this.closed_type;
        closingData.data.closed_description = this.closed_description;
      }

      return this.$store
        .dispatch("opportunityStore/closeOpportunity", closingData)
        .then((response) => {
          if (
            this.willWinTheOpportunity &&
            this.hasImNicEnroll &&
            localStorage.getItem("imNicToken") &&
            !this.pedagogicalWorkflow
          ) {
            this.$store.dispatch("contract/setOpportunityForContract", response.data);

            this.$bvModal.show("bv-enrollment_form");
          }

          if (!deferSaved) this.$emit("saved");

          return response;
        })
        .finally(() => {
          this.hasSaveRequest = false;
        });
    },

    sendContractHistory(history) {
      const contractHistoryData = {
        id: this.unchangedOpportunity.id,
        workspace_id: this.unchangedOpportunity.workspace_id,
        data: history,
      };

      return this.$store
        .dispatch("opportunityStore/sendContractHistory", contractHistoryData)
        .then(() => true)
        .catch(() => false);
    },

    reopenOpportunity(sales_stage_id = null) {
      const newSaleStage = this.$service.findLast(
        this.saleStages,
        (stage) => stage.type !== "Won" && stage.type !== "Lost",
      );

      if (!newSaleStage) {
        this.$bvToast.toast("Não foi possível encontrar um estágio de abertura no workspace atual", {
          title: "Etapa de abertura não encontrada!",
          variant: "danger",
          solid: true,
        });

        return;
      }

      const reOpeningData = {
        id: this.unchangedOpportunity.id,
        workspace_id: this.unchangedOpportunity.workspace_id,

        data: {
          sales_stage_id: sales_stage_id || newSaleStage.id,
        },
      };

      this.$store
        .dispatch("opportunityStore/reopen", reOpeningData)
        .then(() => {
          this.$emit("saved");
        })
        .finally(() => {
          this.hasSaveRequest = false;
        });
    },

    moveOpportunity() {
      this.hasSaveRequest = true;

      const moveData = {
        id: this.unchangedOpportunity.id,
        workspace_id: this.unchangedOpportunity.workspace_id,

        data: {
          sales_stage_id: this.sales_stage_id,
          display_order: "top",
        },
      };

      this.$store
        .dispatch("opportunityStore/move", moveData)
        .then(() => {
          this.$emit("saved");
        })
        .finally(() => {
          this.hasSaveRequest = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.update-opportunity {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .form-holder {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0.5rem 1.5rem 1rem 1.5rem;
    gap: 15px;
    overflow-x: hidden;
    overflow-y: auto;

    legend {
      font-size: 1em;
      padding-top: 0.5em;
      margin-bottom: -5px;
      color: #000000;
    }

    .low-gap-sub-group {
      display: flex;
      flex-direction: column;
      gap: 7px;

      .enrollment-button {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        width: 100%;
        padding: 0.7rem 0;
        gap: 10px;
        border-radius: 5px;
        border: solid 1px #046af3;
        cursor: pointer;

        .enroll-icon {
          font-size: 30px;
          color: #046af3;
        }
      }

      .sgf-contracts {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        margin-top: 10px;
        padding: 13px 1rem 10px 1rem;
        border-radius: 4px;
        border: 1px solid #d2d2d2;
        background: #ffffff;

        .sgf-contracts-title {
          position: absolute;
          top: -9px;
          left: 25px;
          font-weight: 600;
          font-size: 12px;
          padding: 0 5px;
          color: #4c5862;
          background: #ffffff;
        }

        .sgf-contracts-list {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          gap: 5px;
        }

        .sgf-contract-chip {
          font-size: 12px;
          padding: 5px 10px;
          border-radius: 3px;
          border: 1px solid #d2d2d2;
          color: #4c5862;
        }
      }

      .lost-reason-description {
        display: flex;
        flex-direction: column;
        padding: 5px 10px;
        gap: 5px;
        border-radius: 4px;
        border: 1px solid #ff2c55;
        background: #ffbbc7;

        .lost-title {
          text-align: start;
          font-size: 16px;
          color: #000;
        }

        .lost-description {
          text-align: start;
          color: #767383;
        }
      }

      .add-task-button {
        width: 100%;
        padding: 15px;
        transition: 0.4s background ease-in-out;
        box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.2) !important;
        border: none;

        &:hover {
          background: #4594ff !important;
          box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.25) !important;
        }
      }
    }

    .call-component-holder {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 0 1.5rem 10px 1.5rem;
      gap: 10px;

      .call-ongoing {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        height: 46px;
        width: 57%;
        gap: 10px;
        border-radius: 10px;
        border: solid 1px #2ed47a80;
        background: #f5fdf8;
        color: #000000;
      }

      .white-green-circle {
        height: 20px;
        width: 20px;
        margin-right: 5px;
        border-radius: 100%;
        border: solid 4px #2ed47a;
        background: #ffffff;
      }

      .dial-stop {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        height: 46px;
        width: 40%;
        gap: 5px;
        border-radius: 10px;
        border: none;
        background: #ff0025 !important;
        color: #ffffff;
      }

      .warning-text {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.01em;
        text-align: left;
        color: #4c5862;
      }
    }

    .b-tab-style {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 15px;

      .input-field-container {
        margin: 0 !important;
      }

      .attachment-field {
        margin: 0 !important;
      }

      .form-boxes {
        padding: 5px;
        border-radius: 5px;
        margin: 0;
        cursor: pointer;
      }

      .price-field {
        margin: 0 !important;

        .floating {
          float: left;
          font-size: 15px;
          margin-top: -30px;
          margin-left: 16px;
          color: #535e68;
        }

        .price {
          text-align: right;
          background: transparent;
          color: black;
          font-weight: 600;
        }
      }

      .date-input {
        width: 100%;
      }

      :deep(.date-input) {
        .mx-input {
          height: 45px;
        }
      }

      .blocked-content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 10px;
        background: #e5e5e5;
        border: solid 1px #d2d2d2;
        overflow: hidden;
      }

      .edit-lists-redirect {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 10px;
        gap: 5px;
        border-radius: 8px;
        border: solid 1px #046af3;
        color: #046af3;
        cursor: pointer;
      }
    }

    .tab-selector {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 10px 10px 5px 10px;
      border-radius: 5px;
      border: 1px solid #d9d9d9;
      user-select: none;
      color: #31333f;

      .tab-selector-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 5px;
        gap: 10px;
        cursor: pointer;

        .tab-icon {
          font-size: 30px;
        }

        &.active {
          color: #046af3;
          border-bottom: 2px solid #046af3;
        }

        &.disabled {
          color: #6e6b7b;
          cursor: not-allowed;
        }
      }
    }

    .sub-form-group {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 15px;

      .sub-form-group-check {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;

        .custom-checkbox {
          height: 18px;
          width: 18px;
          border-radius: 2px;
          cursor: pointer;
        }

        label {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          color: #6e6b7b;
        }
      }
    }
  }

  .form-holder > * {
    flex-shrink: 0;
  }

  .error-border {
    border-color: #ea5455 !important;
  }

  fieldset.error-border input.price {
    border-color: #ea5455 !important;
  }

  .spinner-holder {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .bottom-menu {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-weight: bold;
    width: 100%;
    padding: 10px;
    margin-top: auto;
    border-top: 1px solid #ececec;
    color: #000000;
    background: #ffffff;
  }

  :deep(#start_timestamp) {
    .ctk-date-time-picker {
      margin: 0px !important;
    }
  }
}
</style>
